import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content-body" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = {
  key: 0,
  class: "title is-5"
}
const _hoisted_8 = {
  key: 1,
  class: "title is-5"
}
const _hoisted_9 = { class: "columns" }
const _hoisted_10 = { class: "column is-one-quarter" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = ["placeholder", "disabled"]
const _hoisted_15 = { class: "column" }
const _hoisted_16 = { class: "field" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = ["placeholder", "disabled"]
const _hoisted_20 = { class: "column" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "control" }
const _hoisted_24 = ["placeholder", "disabled"]
const _hoisted_25 = { class: "column" }
const _hoisted_26 = { class: "field" }
const _hoisted_27 = { class: "label" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = ["placeholder", "disabled"]
const _hoisted_30 = { class: "column" }
const _hoisted_31 = { class: "field" }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "control" }
const _hoisted_34 = ["placeholder", "disabled"]
const _hoisted_35 = { class: "column" }
const _hoisted_36 = { class: "field" }
const _hoisted_37 = { class: "label" }
const _hoisted_38 = { class: "control" }
const _hoisted_39 = { class: "select is-fullwidth" }
const _hoisted_40 = ["placeholder", "disabled"]
const _hoisted_41 = { value: "" }
const _hoisted_42 = { class: "columns" }
const _hoisted_43 = {
  key: 0,
  class: "column is-6"
}
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "column is-2" }
const _hoisted_46 = { class: "field" }
const _hoisted_47 = { class: "label" }
const _hoisted_48 = { class: "control" }
const _hoisted_49 = ["placeholder", "disabled"]
const _hoisted_50 = { class: "column is-4" }
const _hoisted_51 = { class: "field" }
const _hoisted_52 = { class: "label" }
const _hoisted_53 = ["placeholder", "disabled"]
const _hoisted_54 = { class: "columns" }
const _hoisted_55 = { class: "column is-half" }
const _hoisted_56 = { class: "field" }
const _hoisted_57 = { class: "label" }
const _hoisted_58 = { class: "control" }
const _hoisted_59 = ["placeholder", "disabled"]
const _hoisted_60 = { class: "column is-one-quarter" }
const _hoisted_61 = { class: "field" }
const _hoisted_62 = { class: "label" }
const _hoisted_63 = { class: "control" }
const _hoisted_64 = ["placeholder", "disabled"]
const _hoisted_65 = { class: "column is-one-quarter" }
const _hoisted_66 = { class: "field" }
const _hoisted_67 = { class: "label" }
const _hoisted_68 = { class: "control" }
const _hoisted_69 = ["placeholder", "disabled"]
const _hoisted_70 = { class: "header" }
const _hoisted_71 = {
  key: 0,
  class: "title is-6 mt-4"
}
const _hoisted_72 = { class: "content-body" }
const _hoisted_73 = { class: "table-container" }
const _hoisted_74 = {
  key: 0,
  class: "table"
}
const _hoisted_75 = { class: "sticky-column" }
const _hoisted_76 = { class: "" }
const _hoisted_77 = { class: "" }
const _hoisted_78 = { class: "" }
const _hoisted_79 = { class: "" }
const _hoisted_80 = { class: "" }
const _hoisted_81 = { class: "" }
const _hoisted_82 = { class: "" }
const _hoisted_83 = { class: "" }
const _hoisted_84 = {
  key: 0,
  class: ""
}
const _hoisted_85 = { class: "content-body" }
const _hoisted_86 = {
  key: 0,
  class: "header is-flex is-justify-content-space-between"
}
const _hoisted_87 = { class: "content-body" }
const _hoisted_88 = { class: "field is-grouped is-grouped-right" }
const _hoisted_89 = {
  key: 0,
  class: "control"
}
const _hoisted_90 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_91 = {
  key: 1,
  class: "control"
}
const _hoisted_92 = {
  key: 2,
  class: "control"
}
const _hoisted_93 = {
  key: 3,
  class: "control"
}
const _hoisted_94 = { class: "content-body" }
const _hoisted_95 = { class: "header" }
const _hoisted_96 = { class: "title is-5" }
const _hoisted_97 = { class: "field is-grouped is-grouped-right" }
const _hoisted_98 = { class: "control" }
const _hoisted_99 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_100 = { class: "control" }
const _hoisted_101 = { class: "content-body" }
const _hoisted_102 = { class: "header" }
const _hoisted_103 = { class: "title is-5" }
const _hoisted_104 = { class: "field is-grouped is-grouped-right" }
const _hoisted_105 = { class: "control" }
const _hoisted_106 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_107 = { class: "control" }
const _hoisted_108 = { class: "content-body" }
const _hoisted_109 = { class: "header" }
const _hoisted_110 = { class: "title is-5" }
const _hoisted_111 = { class: "field is-grouped is-grouped-right" }
const _hoisted_112 = { class: "control" }
const _hoisted_113 = {
  type: "submit",
  class: "button is-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_CustDataPetTableRow = _resolveComponent("CustDataPetTableRow")!
  const _component_CustDataPetDataForm = _resolveComponent("CustDataPetDataForm")!
  const _component_AppointmentDataForm = _resolveComponent("AppointmentDataForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editCustomerMeth && _ctx.editCustomerMeth(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (!_ctx.getShowingPetRecord)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editCustomerMeth && _ctx.editCustomerMeth(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            (_ctx.getEditingCustomer)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(_ctx.$t('CustomerData.PleaseModifyYourCustomerData')), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.getEditingCustomer)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_8, _toDisplayString(_ctx.$t('CustomerData.YourCustomerData')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('CustomerData.Name')), 1),
                                _createElementVNode("div", _hoisted_13, [
                                  _withDirectives(_createElementVNode("input", {
                                    minlength: 2,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getEditedCustomerData.name) = $event)),
                                    class: "input",
                                    type: "text",
                                    placeholder: _ctx.$t('CustomerData.NamePlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_14), [
                                    [_vModelText, _ctx.getEditedCustomerData.name]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('CustomerData.Email')), 1),
                                _createElementVNode("div", _hoisted_18, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getEditedCustomerData.email) = $event)),
                                    class: "input",
                                    type: "email",
                                    placeholder: _ctx.replaceSpecialCharacters(_ctx.$t('CustomerData.EmailPlaceholder')),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_19), [
                                    [_vModelText, _ctx.getEditedCustomerData.email]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('UserData.PhoneNumber')), 1),
                                _createElementVNode("div", _hoisted_23, [
                                  _withDirectives(_createElementVNode("input", {
                                    minlength: 6,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.getEditedCustomerData.phone) = $event)),
                                    class: "input",
                                    type: "tel",
                                    placeholder: _ctx.$t('UserData.PhoneNumberPlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_24), [
                                    [_vModelText, _ctx.getEditedCustomerData.phone]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('CustomerData.VATNumber')), 1),
                                _createElementVNode("div", _hoisted_28, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getEditedCustomerData.tax_id) = $event)),
                                    class: "input",
                                    type: "text",
                                    placeholder: _ctx.$t('CustomerData.VATNumberPlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_29), [
                                    [_vModelText, _ctx.getEditedCustomerData.tax_id]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('CustomerData.CRMVNumber')), 1),
                                _createElementVNode("div", _hoisted_33, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.getEditedCustomerData.crmv) = $event)),
                                    class: "input",
                                    type: "number",
                                    placeholder: _ctx.$t('CustomerData.CRMVPlaceholder'),
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_34), [
                                    [_vModelText, _ctx.getEditedCustomerData.crmv]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('CustomerData.CRMVState')), 1),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.getEditedCustomerData.crmv_state) = $event)),
                                      placeholder: _ctx.$t('CustomerData.SelectState'),
                                      disabled: !_ctx.getEditingCustomer
                                    }, [
                                      _createElementVNode("option", _hoisted_41, "-- " + _toDisplayString(_ctx.$t('CustomerData.SelectState')) + " --", 1),
                                      _cache[22] || (_cache[22] = _createStaticVNode("<option value=\"AC\" data-v-bbfdf196>Acre</option><option value=\"AL\" data-v-bbfdf196>Alagoas</option><option value=\"AP\" data-v-bbfdf196>Amapá</option><option value=\"AM\" data-v-bbfdf196>Amazonas</option><option value=\"BA\" data-v-bbfdf196>Bahia</option><option value=\"CE\" data-v-bbfdf196>Ceará</option><option value=\"DF\" data-v-bbfdf196>Distrito Federal</option><option value=\"ES\" data-v-bbfdf196>Espírito Santo</option><option value=\"GO\" data-v-bbfdf196>Goiás</option><option value=\"MA\" data-v-bbfdf196>Maranhão</option><option value=\"MT\" data-v-bbfdf196>Mato Grosso</option><option value=\"MS\" data-v-bbfdf196>Mato Grosso do Sul</option><option value=\"MG\" data-v-bbfdf196>Minas Gerais</option><option value=\"PA\" data-v-bbfdf196>Pará</option><option value=\"PB\" data-v-bbfdf196>Paraíba</option><option value=\"PR\" data-v-bbfdf196>Paraná</option><option value=\"PE\" data-v-bbfdf196>Pernambuco</option><option value=\"PI\" data-v-bbfdf196>Piauí</option><option value=\"RJ\" data-v-bbfdf196>Rio de Janeiro</option><option value=\"RN\" data-v-bbfdf196>Rio Grande do Norte</option><option value=\"RS\" data-v-bbfdf196>Rio Grande do Sul</option><option value=\"RO\" data-v-bbfdf196>Rondônia</option><option value=\"RR\" data-v-bbfdf196>Roraima</option><option value=\"SC\" data-v-bbfdf196>Santa Catarina</option><option value=\"SP\" data-v-bbfdf196>São Paulo</option><option value=\"SE\" data-v-bbfdf196>Sergipe</option><option value=\"TO\" data-v-bbfdf196>Tocantins</option>", 27))
                                    ], 8, _hoisted_40), [
                                      [_vModelSelect, _ctx.getEditedCustomerData.crmv_state]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            (_ctx.getEditingCustomer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createElementVNode("div", {
                                    class: "notification is-light is-small",
                                    innerHTML: _ctx.$t('CustomerData.PostalCodeSearchNote')
                                  }, null, 8, _hoisted_44)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('CustomerData.PostalCode')), 1),
                                _createElementVNode("div", _hoisted_48, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.getEditedCustomerData.postal_code) = $event)),
                                    class: "input",
                                    type: "text",
                                    placeholder: _ctx.$t('CustomerData.PostalCodePlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_49), [
                                    [_vModelText, _ctx.getEditedCustomerData.postal_code]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('CustomerData.City')), 1),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["control", { 'is-loading': _ctx.postalCodeIsLoading }])
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.getEditedCustomerData.city) = $event)),
                                    class: "input",
                                    type: "text",
                                    placeholder: _ctx.$t('CustomerData.CityPlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_53), [
                                    [_vModelText, _ctx.getEditedCustomerData.city]
                                  ])
                                ], 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('CustomerData.Address')), 1),
                                _createElementVNode("div", _hoisted_58, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.getEditedCustomerData.address) = $event)),
                                    class: "input",
                                    type: "text",
                                    placeholder: _ctx.$t('CustomerData.AddressPlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_59), [
                                    [_vModelText, _ctx.getEditedCustomerData.address]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('CustomerData.State')), 1),
                                _createElementVNode("div", _hoisted_63, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.getEditedCustomerData.state) = $event)),
                                    class: "input",
                                    type: "text",
                                    placeholder: _ctx.$t('CustomerData.StatePlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_64), [
                                    [_vModelText, _ctx.getEditedCustomerData.state]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('CustomerData.Country')), 1),
                                _createElementVNode("div", _hoisted_68, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.getEditedCustomerData.country) = $event)),
                                    class: "input",
                                    type: "text",
                                    placeholder: _ctx.$t('CustomerData.CountryPlaceholder'),
                                    required: "",
                                    disabled: !_ctx.getEditingCustomer
                                  }, null, 8, _hoisted_69), [
                                    [_vModelText, _ctx.getEditedCustomerData.country]
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    (!_ctx.addingPet && !_ctx.getEditedCustEditingPet && !_ctx.getShowingPetRecord)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_71, _toDisplayString(_ctx.$t('CustomerData.YourPets')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      (!_ctx.addingPet && !_ctx.getEditedCustEditingPet && !_ctx.getShowingPetRecord)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_74, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_75, _toDisplayString(_ctx.$t('PetData.PetName')), 1),
                                _createElementVNode("th", _hoisted_76, _toDisplayString(_ctx.$t('PetData.Owner')), 1),
                                _createElementVNode("th", _hoisted_77, _toDisplayString(_ctx.$t('PetData.Species')), 1),
                                _createElementVNode("th", _hoisted_78, _toDisplayString(_ctx.$t('PetData.Breed')), 1),
                                _createElementVNode("th", _hoisted_79, _toDisplayString(_ctx.$t('PetData.Gender')), 1),
                                _createElementVNode("th", _hoisted_80, _toDisplayString(_ctx.$t('PetData.Birth')), 1),
                                _createElementVNode("th", _hoisted_81, _toDisplayString(_ctx.$t('PetData.Age')), 1),
                                _createElementVNode("th", _hoisted_82, _toDisplayString(_ctx.$t('PetData.FertileStatus')), 1),
                                _createElementVNode("th", _hoisted_83, _toDisplayString(_ctx.$t('PetData.Weight')), 1),
                                (_ctx.considerInsurance)
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_84, _toDisplayString(_ctx.$t('PetData.InsurancePolicy')), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('General.Operations')), 1)
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEditedCustomerPets, (pet) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: pet.pet_id
                                }, [
                                  _createVNode(_component_CustDataPetTableRow, {
                                    "pet-data": pet,
                                    language: _ctx.language
                                  }, null, 8, ["pet-data", "language"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    (!_ctx.addingPet && !_ctx.getEditedCustEditingPet
              && _ctx.getEditingCustomer && !_ctx.getShowingPetRecord)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              class: "button is-primary",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toggleAddingPet && _ctx.toggleAddingPet(...args)))
                            }, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('CustomerData.NewPet')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      (!_ctx.addingPet && !_ctx.getEditedCustEditingPet && _ctx.getEditingCustomer && !_ctx.getShowingPetRecord)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_89, [
                            _createElementVNode("button", _hoisted_90, _toDisplayString(_ctx.$t('General.Save')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.addingPet && !_ctx.getEditedCustEditingPet && _ctx.getEditingCustomer && !_ctx.getShowingPetRecord)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_91, [
                            _createElementVNode("a", {
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args))),
                              class: "button is-light"
                            }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.addingPet && !_ctx.getEditedCustEditingPet && !_ctx.getEditingCustomer && !_ctx.getShowingPetRecord && !_ctx.getCustDetailing)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_92, [
                            _createElementVNode("a", {
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.iniCustomerEditing && _ctx.iniCustomerEditing(...args))),
                              class: "button is-primary"
                            }, _toDisplayString(_ctx.$t('General.ModifyData')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getCustDetailing && !_ctx.getShowingPetRecord)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_93, [
                            _createElementVNode("a", {
                              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.endCustDetailing && _ctx.endCustDetailing(...args))),
                              class: "button is-primary"
                            }, _toDisplayString(_ctx.$t('General.Back')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    (_ctx.addingPet)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addPetMeth && _ctx.addPetMeth(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("h5", _hoisted_96, _toDisplayString(_ctx.$t('CustomerData.AddNewPet')), 1)
                          ]),
                          _createVNode(_component_CustDataPetDataForm, { ref: "refNewPetDataForm" }, null, 512),
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("p", _hoisted_98, [
                              _createElementVNode("button", _hoisted_99, _toDisplayString(_ctx.$t('General.Add')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_100, [
                              _createElementVNode("a", {
                                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toggleAddingPet && _ctx.toggleAddingPet(...args))),
                                class: "button is-light"
                              }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                            ])
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    (_ctx.getEditedCustEditingPet)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editPetMeth && _ctx.editPetMeth(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("h5", _hoisted_103, _toDisplayString(_ctx.$t('CustomerData.EditPet')), 1)
                          ]),
                          _createVNode(_component_CustDataPetDataForm, { ref: "refEditedPetDataForm" }, null, 512),
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("p", _hoisted_105, [
                              _createElementVNode("button", _hoisted_106, _toDisplayString(_ctx.$t('General.Edit')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_107, [
                              _createElementVNode("a", {
                                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cancelEditPet && _ctx.cancelEditPet(...args))),
                                class: "button is-light"
                              }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                            ])
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    (_ctx.getShowingPetRecord)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.endShowingPetRecordMeth && _ctx.endShowingPetRecordMeth(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("h5", _hoisted_110, _toDisplayString(_ctx.$t('PetData.PetHistoricalRecord')), 1)
                          ]),
                          _createVNode(_component_CustDataPetDataForm, { ref: "refPetRecordDataForm" }, null, 512),
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("p", _hoisted_112, [
                              _createElementVNode("button", _hoisted_113, _toDisplayString(_ctx.$t('General.Back')), 1)
                            ])
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ])
                ], 32))
              : _createCommentVNode("", true),
            (_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createBlock(_component_AppointmentDataForm, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}